module.exports = __webpack_public_path__ + "img/2.42d1fe1f.png";